<!-- eslint-disable -->
<template lang="pug">
    .homeworks-banner
        template(v-if="!isLoading")
            .homeworks-banner__header
                | {{ $i18n.t('dashboard.dashboard_education_homework') }}
            .homeworks-banner__body
                template(v-if="displayedHomeworks.length")
                    .homework(v-for="homework in displayedHomeworks")
                        .homework__date(:class="{'homework__date--uncompleted': homework.isOverdue}")
                            | {{ formatDate(homework.date) }}
                        divider(:margin="'0 auto'" :not-show-last-child="true")
                        template(v-for="exercise in homework.exercises")
                            .exercise
                                .exercise__game-name
                                    | {{ getGameName(exercise) }}
                                .exercise__button
                                    cs-button(
                                        v-if="!exercise.isCompleted"
                                        color="blue"
                                        @click="$router.push(getGameRoute(homework, exercise))"
                                        :disabled="isHomeworkDisabled(homework)"
                                    )
                                        | {{ $i18n.t('dashboard.dashboard_education_startGame') }}
                                    cs-button(v-else :disabled="true")
                                        | {{ $i18n.t('dashboard.dashboard_education_completedGame') }}
                            divider(:margin="'0 auto'" :not-show-last-child="true")
                .homeworks-banner__empty(v-else="")
                    | {{ $i18n.t('dashboard.dashboard_homeworks_empty') }}
        cs-loader(v-else="")
</template>

<script>
    /*eslint-disable*/
    import { mapState } from 'vuex';
    import Trainer from '../../../utils/trainer/trainer.js';
    import BillingBlockMixin from '../../../utils/user/BillingBlockMixin';
    import HomeworkApi from '../../../api/homework/homework.js';
    import moment from 'moment';
    import _ from 'lodash';

    export default {
        mixins: [BillingBlockMixin, Trainer],
        computed: {
            ...mapState({
                user: state => state.auth.user,
                selectedCourse: state => state.trainer.course,
            }),
            displayedHomeworks() {
                return this.homeworks
                    ? this.homeworks.filter(
                          homework =>
                              homework.exercises.length > 0 &&
                              homework.exercises[0].courseType === _.kebabCase(this.selectedCourse)
                      )
                    : [];
            },
        },
        data() {
            return {
                homeworks: null,
                serverDate: null,
                isLoading: false,
            };
        },
        mounted() {
            this.fetchData();
        },
        methods: {
            fetchData() {
                this.isLoading = true;
                HomeworkApi.uncompletedHomework({ course: this.selectedCourse })
                    .then(response => {
                        this.homeworks = _.orderBy(response.homeworks, 'date');
                        this.serverDate = response.serverDate;
                        this.isLoading = false;
                    })
                    .catch(() => {
                        this.isLoading = false;
                    });
            },
            getGameRoute(homework, exercise) {
                return {
                    name: this.getRouteName(exercise),
                    params: {
                        exerciseId: exercise.id,
                        homeworkId: homework.id,
                        type: this.getRouteGameType(exercise),
                    },
                };
            },
            getRouteGameType(exercise) {
                if (exercise.parameters.hasOwnProperty(`usersU${this.user.id}`)) {
                    if (exercise.parameters[`usersU${this.user.id}`].withTime) {
                        return exercise.slug + 'WithTime';
                    }
                    return exercise.slug;
                }

                if (exercise.parameters.default.withTime) {
                    return exercise.slug + 'WithTime';
                }
                return exercise.slug;
            },
            getRouteName(exercise) {
                return 'browse:game';
            },
            isHomeworkDisabled(homework) {
                return (
                    !homework.isOverdue ||
                    homework.isBlocked ||
                    this.isBeforeServerTime(homework) ||
                    this.areSchoolsBlocked ||
                    homework.isFromBlockedSchool
                );
            },
            isBeforeServerTime(homework) {
                return moment(this.serverDate).isBefore(moment(homework.dateAsIsoString));
            },
            formatDate(date) {
                return moment(date).format('DD MMMM');
            },
        },
    };
</script>

<style lang="scss" scoped>
    .homeworks-banner {
        padding: 30px;
        box-sizing: border-box;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        &:not(:last-child) {
            margin-bottom: 30px;
        }
    }

    .homeworks-banner__header {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        margin-bottom: 25px;
    }

    .homeworks-banner__body {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
    }

    .homeworks-banner__empty {
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 21px;
    }

    .homework__date {
        font-size: 18px;
        line-height: 21px;
        margin-bottom: 25px;
    }

    .homework__date--uncompleted {
        color: $hsl-color-red-62;
    }

    .exercise {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 20px 0;
    }
    .exercise__button {
        margin-left: 10px;
    }
</style>
